import React from 'react'
import DatePicker from 'components/DatePicker'

export default function Date ({
  date,
  onDateChange,

  ...restProps
}) {
  return (
    <DatePicker
      {...restProps}
      showHour
      date={date}
      onChange={onDateChange}
    />
  )
}
